import { PICTREE } from "../../constants";

const initialHomePhotoShoot = {
  countDenchu: undefined,
  countUniqueUser: undefined,
  countNewUser: undefined,
  countPic: undefined,
  countAsset: undefined,
  countDupeDenchu: undefined,
  countReviewOk: undefined,
  progressDenchu: { taken: 0, max: 0, maxByasset: 0 },
  timings: {}, // {key: ms}
  errors:  {}, // {key: message}
};

const initialState = {
  homeDataUser: {},
  homeDataCheckIn: {},
  homeDataPhotoShoot: initialHomePhotoShoot,
  dataPhotoShootByAsset: [],
  dataPhotoShootDetails: [],
  registTrend: [],
  registTable: [],
  usersOverview: [],
  usersList: [],
  userPageNumber: 1,
  salesOverview: [],
  salesTrend: [],
  salesTable: [],
  pointOverview: [],
  pointTrend: [],
  pointTable: [],
  checkInTrend: [],
  dataCheckInMap: [],
  dataCheckInTable: [],
  pictreeView: null,
  photoShootTrend: [],
  photoShootDenchuKaisuTrend: [],
  chartSize: "day",
  mapType: "taken+untaken",
  photoShootMapData: [],
  missionData: [],
  missionSummaryData: {},
  missionRankingData: [],
  rewardCoinSummaryData: {},
  rewardCoinData: [],
  rewardCoinRankingData: [],
  budgetSummary: null,
  budgetRemainingTrend: null,
  budgetBySourceRows: [],
  budgetByBoostRows: [],
  dateRangePicTree: [null, null],
  periodType: "season",
  selectedSeason: [],
  seasonData: [],
  byAreaDataSummary: [],
  byAreaDataTable: [],
  missionData: [],
  selectedMission: "blank",
  photoShootTrendByAsset: [],
};

const mergeBudgetSummary = (currentSummary, nextSummary) => {
  if (nextSummary === null) {
    return null;
  }

  const merged = {
    ...(currentSummary || {}),
    ...(nextSummary || {}),
  };

  const totalBudgetAmount = Number(merged.totalBudgetAmount || 0);
  const consumedBudgetAmount = Number(merged.consumedBudgetAmount || 0);
  const remainingBudgetAmount = Number(merged.remainingBudgetAmount || 0);

  return {
    ...merged,
    totalBudgetAmount,
    consumedBudgetAmount,
    remainingBudgetAmount,
    boostEventCount:
      merged.boostEventCount === undefined || merged.boostEventCount === null
        ? merged.boostEventCount
        : Number(merged.boostEventCount),
    consumedRate:
      totalBudgetAmount > 0
        ? Number(((consumedBudgetAmount / totalBudgetAmount) * 100).toFixed(1))
        : null,
  };
};

export default function pictreeNttReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_HOME_USER:
      return {
        ...state,
        homeDataUser: action.payload,
      };
    case PICTREE.SET_HOME_CHECKIN_NTT_FT:
      return {
        ...state,
        homeDataCheckIn: action.payload,
      };
    case PICTREE.SET_HOME_PHOTOSHOOT_NTT_FT:
      return {
        ...state,
        homeDataPhotoShoot: action.payload,
      };
    case PICTREE.PATCH_HOME_PICTREE_PHOTO_SHOOT_NTT_FT:
      return {
        ...state,
        homeDataPhotoShoot: {
          ...state.homeDataPhotoShoot,
          ...action.payload,
          progressDenchu: {
            ...(state.homeDataPhotoShoot.progressDenchu || {}),
            ...(action.payload.progressDenchu || {}),
          },
          timings: {
            ...(state.homeDataPhotoShoot.timings || {}),
            ...(action.payload.timings || {}),
          },
          errors: {
            ...(state.homeDataPhotoShoot.errors || {}),
            ...(action.payload.errors || {}),
          },
        },
      };
    case PICTREE.SET_PHOTOSHOOT_BY_ASSET_NTT_FT:
      return {
        ...state,
        dataPhotoShootByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_BY_ASSET_NTT_FT:
      return {
        ...state,
        photoShootTrendByAsset: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DETAILS:
      return {
        ...state,
        dataPhotoShootDetails: action.payload,
      };
    case PICTREE.SET_REGIST_TREND:
      return {
        ...state,
        registTrend: action.payload,
      };
    case PICTREE.SET_REGIST_TABLE:
      return {
        ...state,
        registTable: action.payload,
      };
    case PICTREE.SET_SALES_OVERVIEW:
      return {
        ...state,
        salesOverview: action.payload,
      };
    case PICTREE.SET_SALES_TREND:
      return {
        ...state,
        salesTrend: action.payload,
      };
    case PICTREE.SET_SALES_TABLE:
      return {
        ...state,
        salesTable: action.payload,
      };
    case PICTREE.SET_POINT_OVERVIEW:
      return {
        ...state,
        pointOverview: action.payload,
      };
    case PICTREE.SET_POINT_TREND:
      return {
        ...state,
        pointTrend: action.payload,
      };
    case PICTREE.SET_POINT_TABLE:
      return {
        ...state,
        pointTable: action.payload,
      };
    case PICTREE.SET_CHECKIN_TREND_NTT_FT:
      return {
        ...state,
        checkInTrend: action.payload,
      };
    case PICTREE.SET_CHECKIN_MAP:
      return {
        ...state,
        dataCheckInMap: action.payload,
      };
    case PICTREE.SET_CHECKIN_TABLE:
      return {
        ...state,
        dataCheckInTable: action.payload,
      };
    case PICTREE.SET_PICTREE_VIEW:
      return {
        ...state,
        pictreeView: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_TREND_NTT_FT:
      return {
        ...state,
        photoShootTrend: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_DENCHU_KAISU_TREND:
      return {
        ...state,
        photoShootDenchuKaisuTrend: action.payload,
      };
    case PICTREE.SET_USER_LIST:
      return {
        ...state,
        usersList: action.payload,
      };
    case PICTREE.SET_PICTREE_USER_PAGE_NUMBER:
      return {
        ...state,
        userPageNumber: action.payload,
      };
    case PICTREE.SET_CHART_SIZE:
      return {
        ...state,
        chartSize: action.payload,
      };
    case PICTREE.SET_MAP_TYPE:
      return {
        ...state,
        mapType: action.payload,
      };
    case PICTREE.SET_PHOTOSHOOT_MAP_DATA_NTT_FT:
      return {
        ...state,
        photoShootMapData: action.payload,
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_MISSION_SUMMARY_DATA:
      return {
          ...state,
          missionSummaryData: action.payload
      };
    case PICTREE.SET_MISSION_RANKING_DATA:
      return {
          ...state,
          missionRankingData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_SUMMARY_DATA:
      return {
          ...state,
          rewardCoinSummaryData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_DATA:
      return {
          ...state,
          rewardCoinData: action.payload
      };
    case PICTREE.SET_REWARD_COIN_RANKING_DATA:
      return {
          ...state,
          rewardCoinRankingData: action.payload
      };
    case PICTREE.SET_BUDGET_SUMMARY_DATA_NTT_FT:
      return {
        ...state,
        budgetSummary: mergeBudgetSummary(state.budgetSummary, action.payload)
      };
    case PICTREE.SET_BUDGET_REMAIN_TREND_DATA_NTT_FT:
      return {
        ...state,
        budgetRemainingTrend: action.payload || null,
        budgetBySourceRows: action.payload?.bySourceRows || [],
      };
    case PICTREE.SET_BUDGET_BOOST_DATA_NTT_FT:
      return {
        ...state,
        budgetByBoostRows: action.payload || [],
      };
    case PICTREE.SET_PERIOD_TYPE:
      return {
        ...state,
          periodType: action.payload
      };
    case PICTREE.SET_SELECTED_SEASON_NTT_FT:
      return {
          ...state,
          selectedSeason: action.payload || []
      };
    case PICTREE.SET_SEASON_DATA_NTT_FT:
      return {
          ...state,
          seasonData: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_SUMMARY_NTT_FT:
      return {
        ...state,
        byAreaDataSummary: action.payload
      };
    case PICTREE.SET_BY_AREA_DATA_TABLE_NTT_FT:
      return {
        ...state,
        byAreaDataTable: action.payload
      };
    case PICTREE.SET_MISSION_DATA:
      return {
          ...state,
          missionData: action.payload
      };
    case PICTREE.SET_SELECTED_MISSION:
      return {
          ...state,
          selectedMission: action.payload
      };
    default:
      return state;
  }
}
